import React, { useState, useRef } from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import useMediaQuery from '@mui/material/useMediaQuery';
import '../../../component/ReuseableComponent/ReuseableComponent.css';
import Modal from '@mui/material/Modal';
import '../../../component/ToolBox/ToolBox.css';
import '../../Order/Order.css';
import {
  CmpTypographyField,
  CmpInputField,
  CmpButtonWithIcon
} from '../../../component/ToolBox/ToolBox';
import CloseIcon from '@mui/icons-material/Close';
import { Download } from '@mui/icons-material';
import moment from 'moment';
import { DataGrid } from '@mui/x-data-grid';
import { CSVLink } from 'react-csv';
import { getDCMarginExport } from '../actions';
import { fAlertToast } from '../../../Utility/Utilitys';

const fDummyFunction = () => {};

const dataGridSx = {
  border: '1px solid #e0e0e0',
  borderRadius: '4px',
  fontSize: '0.75rem',
  '& .MuiDataGrid-columnHeaders': {
    backgroundColor: '#0d73bb',
    color: '#fff',
    fontSize: '0.7rem',
    fontWeight: 600,
    minHeight: '36px !important',
    maxHeight: '36px !important',
  },
  '& .MuiDataGrid-columnHeaderTitle': {
    fontWeight: 600,
    fontSize: '0.7rem',
  },
  '& .MuiDataGrid-sortIcon': {
    color: '#fff',
  },
  '& .MuiDataGrid-cell': {
    fontSize: '0.7rem',
    fontFamily: 'Montserrat, Lato, sans-serif',
    borderBottom: '1px solid #f0f0f0',
  },
  '& .MuiDataGrid-cell:focus': {
    outline: 'none',
  },
  '& .MuiDataGrid-cell--editable': {
    backgroundColor: '#fffde7',
    borderBottom: '1px solid #0d73bb !important',
    cursor: 'pointer',
  },
  '& .MuiDataGrid-cell--editing': {
    backgroundColor: '#e3f2fd !important',
  },
};

const labelSx = { fontWeight: 600, color: '#0d73bb' };

const DCMarginPosting = ({
  xOpen = 'false',
  xTitle = '',
  fCloseModal,
  xPostedRowInfo = [],
  xLoadDetailRow = [],
  xLoadDetailCol = [],
  xfetchPost = () => {},
  xRowHeight = 30,
  xHeaderHeight = 40,
  setLoadDetailRow
}) => {
  const vMediaQuery = useMediaQuery('(max-width:650px)');

  const isPosted = xPostedRowInfo.docStatus === 'POST';

  const [sExportDetailData, setExportDetailData] = useState([]);
  const [sExportRSPData, setExportRSPData] = useState([]);
  const csvDetailRef = useRef(null);
  const csvRSPRef = useRef(null);

  const fExportDetail = async () => {
    const obj = { v_VocTyp: xPostedRowInfo.vocTyp, v_VocNo: xPostedRowInfo.vocNo, v_Type: xPostedRowInfo.type };
    const result = await getDCMarginExport(obj);
    if (result?.ResultSet?.length > 0) {
      const data = result.ResultSet.map((i) => ({
        'Item Code': i.ItemCode,
        'Item Name': i.ItemName,
        'Unit': i.Unit,
        'Purchase Cost': i.PurchaseCost,
        'WH Stock': i.WHStock,
        'WH Avg Cost': i.WHAvgCost,
        'New RSP': i.NewRSP,
        'New GP%': i.NewGP
      }));
      setExportDetailData(data);
      setTimeout(() => csvDetailRef.current?.link?.click(), 100);
    } else {
      fAlertToast('FAILED', 'No data to export');
    }
  };

  const fExportRSP = async () => {
    const obj = { v_VocTyp: xPostedRowInfo.vocTyp, v_VocNo: xPostedRowInfo.vocNo, v_Type: xPostedRowInfo.type };
    const result = await getDCMarginExport(obj);
    if (result?.ResultSet?.length > 0) {
      const data = result.ResultSet.map((i) => ({
        'Item Code': i.ItemCode,
        'Item Name': i.ItemName,
        'Unit': i.Unit,
        'New RSP': i.NewRSP
      }));
      setExportRSPData(data);
      setTimeout(() => csvRSPRef.current?.link?.click(), 100);
    } else {
      fAlertToast('FAILED', 'No data to export');
    }
  };

  const addMargin = (params) => {
    let itemList = xLoadDetailRow.map((i) => {
      return i.id === params.row.id
        ? {
            ...i,
            TRNS_Add_Margin_CTN: Number(params.value),
            TRNS_Add_Margin_Net: params?.row?.TRNS_QTY * Number(params.value),
            TRNS_TSR_RSP: params?.row?.TRNS_UnitRate + Number(params.value)
          }
        : i;
    });
    setLoadDetailRow(itemList);
    return {
      ...params.row,
      TRNS_Add_Margin_CTN: Number(params.value),
      TRNS_Add_Margin_Net: params?.row?.TRNS_QTY * Number(params.value),
      TRNS_TSR_RSP: params?.row?.TRNS_UnitRate + Number(params.value)
    };
  };

  const columns = xLoadDetailCol.map((x) => {
    if (x.field === 'TRNS_Add_Margin_CTN') {
      return {
        ...x,
        valueSetter: addMargin,
        editable: !isPosted,
        cellClassName: isPosted ? '' : 'mui-request-grid-final-qty'
      };
    } else {
      return x;
    }
  });

  return (
    <Modal
      open={xOpen}
      onClose={fCloseModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description">
      <Box
        sx={{
          flexGrow: 1,
          overflow: 'auto',
          display: 'flex',
          flexDirection: 'column',
          borderRadius: '4px'
        }}
        className="model-gc-search">
        {/* [A] HEADER BAR */}
        <Grid
          container
          spacing={0}
          columns={{ xs: 12 }}
          className="post-Modal-title"
          sx={{
            alignItems: 'center',
            borderRadius: '4px 4px 0 0',
            fontSize: '15px',
            letterSpacing: '0.5px'
          }}>
          <Grid item xs={11} sm={11} md={11} sx={{ textAlign: 'center' }}>
            <span style={{ fontWeight: 600 }}>{xTitle}</span>
          </Grid>
          <Grid item xs={1} sm={1} md={1} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            <CloseIcon
              onClick={!!fCloseModal ? fCloseModal : fDummyFunction}
              sx={{
                cursor: 'pointer',
                color: '#fff',
                '&:hover': { opacity: 0.8 },
                zIndex: 999
              }}
            />
          </Grid>
        </Grid>

        {/* [B] INFO CARD */}
        <Box
          sx={{
            mx: 1,
            mt: 1,
            mb: 0.5,
            p: 1,
            backgroundColor: '#f8f9fa',
            borderRadius: '4px',
            border: '1px solid #e0e0e0'
          }}>
          {/* Row 1: Voucher Type, Voucher No, Date */}
          <Grid container spacing={1} alignItems="center">
            <Grid item xs={12} sm={12} md={5}>
              <Grid container alignItems="center" spacing={0.5}>
                <Grid item xs={3} sm={3} md={2.5}>
                  <CmpTypographyField
                    xcomponent={'span'}
                    xText={'Voucher Type'}
                    xVariant={'subtitle2'}
                    sx={labelSx}
                  />
                </Grid>
                <Grid item xs={9} sm={9} md={9.5}>
                  <Grid container spacing={0.5} alignItems="center">
                    <Grid item xs={3} sm={3} md={2}>
                      <CmpInputField
                        xValue={xPostedRowInfo.vocTyp}
                        xType={'text'}
                        xName={'docNo'}
                        xReadOnly={true}
                        xOnChange={''}
                        xError={false}
                        xErrorMessage={''}
                        xOnKeyUp={''}
                      />
                    </Grid>
                    <Grid item xs={9} sm={9} md={10}>
                      <CmpInputField
                        xValue={xPostedRowInfo.vocName}
                        xType={'text'}
                        xName={'docName'}
                        xReadOnly={true}
                        xOnChange={''}
                        xError={false}
                        xErrorMessage={''}
                        xOnKeyUp={''}
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} sm={6} md={3.5}>
              <Grid container alignItems="center" spacing={0.5}>
                <Grid item xs={3} sm={3} md={3}>
                  <CmpTypographyField
                    xcomponent={'span'}
                    xText={'Voucher No'}
                    xVariant={'subtitle2'}
                    sx={labelSx}
                  />
                </Grid>
                <Grid item xs={9} sm={9} md={9}>
                  <CmpInputField
                    xValue={xPostedRowInfo.vocNo}
                    xType={'text'}
                    xName={'vocNo'}
                    xReadOnly={true}
                    xOnChange={''}
                    xError={false}
                    xErrorMessage={''}
                    xOnKeyUp={''}
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} sm={6} md={3.5}>
              <Grid container alignItems="center" spacing={0.5}>
                <Grid item xs={3} sm={3} md={3}>
                  <CmpTypographyField
                    xcomponent={'span'}
                    xText={'Date'}
                    xVariant={'subtitle2'}
                    sx={labelSx}
                  />
                </Grid>
                <Grid item xs={9} sm={9} md={9}>
                  <CmpInputField
                    xValue={moment(xPostedRowInfo.vocDt).format('DD/MM/YYYY')}
                    xType={'text'}
                    xName={'date'}
                    xReadOnly={true}
                    xOnChange={''}
                    xError={false}
                    xErrorMessage={''}
                    xOnKeyUp={''}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          {/* Row 2: Location, Status, Type */}
          <Grid container spacing={1} alignItems="center" sx={{ mt: 0.5 }}>
            <Grid item xs={12} sm={12} md={5}>
              <Grid container alignItems="center" spacing={0.5}>
                <Grid item xs={3} sm={3} md={2.5}>
                  <CmpTypographyField
                    xcomponent={'span'}
                    xText={'Location'}
                    xVariant={'subtitle2'}
                    sx={labelSx}
                  />
                </Grid>
                <Grid item xs={9} sm={9} md={9.5}>
                  <Grid container spacing={0.5} alignItems="center">
                    <Grid item xs={3} sm={3} md={2}>
                      <CmpInputField
                        xValue={xPostedRowInfo.locCode}
                        xType={'text'}
                        xName={'locCode'}
                        xReadOnly={true}
                        xOnChange={''}
                        xError={false}
                        xErrorMessage={''}
                        xOnKeyUp={''}
                      />
                    </Grid>
                    <Grid item xs={9} sm={9} md={10}>
                      <CmpInputField
                        xValue={xPostedRowInfo.locName}
                        xType={'text'}
                        xName={'locName'}
                        xReadOnly={true}
                        xOnChange={''}
                        xError={false}
                        xErrorMessage={''}
                        xOnKeyUp={''}
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} sm={6} md={3.5}>
              <Grid container alignItems="center" spacing={0.5}>
                <Grid item xs={3} sm={3} md={3}>
                  <CmpTypographyField
                    xcomponent={'span'}
                    xText={'Status'}
                    xVariant={'subtitle2'}
                    sx={labelSx}
                  />
                </Grid>
                <Grid item xs={9} sm={9} md={9}>
                  <Box
                    sx={{
                      display: 'inline-flex',
                      alignItems: 'center',
                      px: 1.5,
                      py: 0.3,
                      borderRadius: '12px',
                      fontWeight: 600,
                      fontSize: '0.75rem',
                      fontFamily: 'Montserrat, Lato, sans-serif',
                      color: '#fff',
                      backgroundColor: isPosted ? '#019F4B' : '#0d73bb',
                      letterSpacing: '0.5px'
                    }}>
                    {xPostedRowInfo.docStatus || 'ENTER'}
                  </Box>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} sm={6} md={3.5}>
              <Grid container alignItems="center" spacing={0.5}>
                <Grid item xs={3} sm={3} md={3}>
                  <CmpTypographyField
                    xcomponent={'span'}
                    xText={'Type'}
                    xVariant={'subtitle2'}
                    sx={labelSx}
                  />
                </Grid>
                <Grid item xs={9} sm={9} md={9}>
                  <CmpInputField
                    xValue={xPostedRowInfo.type}
                    xType={'text'}
                    xName={'type'}
                    xReadOnly={true}
                    xOnChange={''}
                    xError={false}
                    xErrorMessage={''}
                    xOnKeyUp={''}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Box>

        {/* [C] DATA GRID */}
        <Box
          sx={{
            mx: 1,
            mt: 0.5,
            mb: 0,
            flexGrow: 1,
            height: vMediaQuery ? 'calc(90vh - 200px)' : 'calc(90vh - 190px)',
            p: 0.5
          }}>
          <DataGrid
            rows={xLoadDetailRow}
            columns={columns}
            rowHeight={xRowHeight}
            headerHeight={xHeaderHeight}
            sx={dataGridSx}
            componentsProps={{
              filterPanel: { sx: { maxWidth: '93vw' } }
            }}
            getRowClassName={(params) =>
              params.indexRelativeToCurrentPage % 2 === 0 ? 'mui-even-row' : 'mui-odd-row'
            }
            hideFooter
            checkboxSelection={false}
          />
        </Box>

        {/* [D] ACTION BAR */}
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
            gap: 1,
            px: 1.5,
            py: 0.5,
            mx: 1,
            borderTop: '1px solid #e0e0e0',
            backgroundColor: '#fafafa',
            borderRadius: '0 0 4px 4px',
            '& .mui-btn-wt-icon': { width: 'auto', minWidth: '80px' }
          }}>
          <CmpButtonWithIcon
            xvariant={'contained'}
            xsize={'small'}
            xonClick={fExportDetail}
            xLabel={'Export Detail'}
            xIcon={<Download />}
          />
          <CSVLink
            ref={csvDetailRef}
            data={sExportDetailData}
            filename={`Transfer_Detail_${xPostedRowInfo.vocNo}.csv`}
            style={{ display: 'none' }}
          />
          <CmpButtonWithIcon
            xvariant={'contained'}
            xsize={'small'}
            xonClick={fExportRSP}
            xLabel={'Export RSP'}
            xIcon={<Download />}
          />
          <CSVLink
            ref={csvRSPRef}
            data={sExportRSPData}
            filename={`Transfer_RSP_${xPostedRowInfo.vocNo}.csv`}
            style={{ display: 'none' }}
          />
          <CmpButtonWithIcon
            xvariant={'contained'}
            xsize={'small'}
            xonClick={() => {
              xfetchPost(xPostedRowInfo, false);
            }}
            xLabel={'Save'}
            xIcon={''}
            xDisable={isPosted}
          />
          <CmpButtonWithIcon
            xvariant={'contained'}
            xColor={'success'}
            xsize={'small'}
            xonClick={() => {
              xfetchPost(xPostedRowInfo, true);
            }}
            xLabel={'Post'}
            xIcon={''}
            xDisable={isPosted}
          />
        </Box>
      </Box>
    </Modal>
  );
};

export default DCMarginPosting;
